import React from 'react';
import { healthStatuses } from '../../data/health-status-data-algo-edit';
import HealthStatus from './HealthStatus';

const HealthStatusWithText = ({
  status = '',
  baseLabel = '',
  className = '',
  size = '',
  onClick,
}) => {
  let { text: statusText = '', color: statusColor = '' } = healthStatuses[
    status
  ]
    ? healthStatuses[status]
    : {};

  statusText = statusText ? `${baseLabel}: ${statusText}` : baseLabel;

  return (
    <HealthStatus
      color={statusColor}
      name={statusText}
      className={className}
      size={size}
      onClick={onClick}
    />
  );
};

export default HealthStatusWithText;
